const formTemplate = (editor) => {

    editor.BlockManager.add('formTemplate', {
        category: `Built In Templates`,
        label: `Form Template`,
        attributes: {},
        content: `
            <div>
                <nav class="navbar navbar-expand-lg navbar-light bg-light">
                    <div class="container px-4 px-lg-5">
                        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></button>
                        <div class="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul class="navbar-nav me-auto mb-2 mb-lg-0 ms-lg-4">
                                <li class="nav-item nav-link active pointer" aria-current="page" href="#!">Home</li>
                                <li class="nav-item dropdown">
                                    <span class="nav-link dropdown-toggle pointer" id="navbarDropdown" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Actions</span>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                        <li><span class="dropdown-item pointer" href="#!">Create a project</span></li>
                                        <li><span class="dropdown-item pointer" href="#!">Create a task</span></li>
                                        <li><span class="dropdown-item pointer" href="#!">Create a workpackage</span></li>
                                        <li><span class="dropdown-item pointer" href="#!">Create a deliverable</span></li>
                                    </ul>
                                </li>
                                <li class="nav-item nav-link pointer" href="#!">Tasks</li>
                            </ul>
                        </div>
                    </div>
                </nav>
                <header class="bg-dark py-2">
                    <div class="container px-4 px-lg-5">
                        <div class="text-center text-white">
                            <h1 class="display-4 fw-bolder">Add a project</h1>
                            <p class="lead fw-normal text-white-50 mb-0">Use this form to add a project to the list of projects</p>
                        </div>
                    </div>
                </header>
                <section class="py-5 height-section">
                    <div class="container px-4 px-lg-5">
                        <form>
                            <div class="form-group flex">
                                <label class="col-form-label" >Title</label>
                                <input type="text" placeholder="title" class="form-control margin-left" required />
                            </div>
                            <div class="form-group flex">
                                <label class="col-form-label" >Image</label>
                                <input class="form-control margin-left" type="file" id="formFile">
                            </div>
                            <div class="form-group flex">
                                <label for="date" class="col-form-label" >Start</label>
                                <div class="input-group date margin-left" id="datepicker">
                                    <input type="text" class="form-control" id="date"/>
                                    <span class="input-group-append">
                                        <span class="input-group-text bg-light d-block">
                                            <i class="fa fa-calendar"></i>
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group flex">
                                <label for="date" class="col-form-label" >End</label>
                                <div class="input-group date margin-left" id="datepicker">
                                    <input type="text" class="form-control" id="date"/>
                                    <span class="input-group-append">
                                        <span class="input-group-text bg-light d-block">
                                            <i class="fa fa-calendar"></i>
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group flex">
                                <label class="col-form-label">Description</label>
                                <textarea class="form-control margin-left"></textarea>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary pointer">Create</button>
                            </div>
                        </form>
                    </div>
                </section>
                <footer class="py-5 bg-dark">
                    <div class="container"><p class="m-0 text-center text-white">Copyright &copy; ViLabs 2022</p></div>
                </footer>
            </div>
        `
    })

}

export default formTemplate;